/**
 * "há 12 min", "há 3 h", "há 2 dias" — F136.
 *
 * Para o que se lê de relance: quanto tempo um pedido do caixa está esperando,
 * desde quando um produto está na fila de etiquetas. Minutos e horas abreviados
 * porque cabem num cartão; dias por extenso porque "2 d" ninguém lê.
 */
export const timeAgo = (iso: string, now: number = Date.now()): string => {
  const elapsedMs = now - new Date(iso).getTime()
  if (!Number.isFinite(elapsedMs)) return ''
  const minutes = Math.floor(elapsedMs / 60_000)
  if (minutes < 1) return 'agora'
  if (minutes < 60) return `há ${String(minutes)} min`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `há ${String(hours)} h`
  const days = Math.floor(hours / 24)
  return days === 1 ? 'há 1 dia' : `há ${String(days)} dias`
}
